import React, { PropsWithChildren } from 'react';

import {
    FlingGesture,
    Gesture,
    GestureDetector,
    PinchGesture,
} from 'react-native-gesture-handler';

import { isWeb } from 'utils/responsiveness';

function GestureHandlerComponent({
    children,
    gestures,
}: PropsWithChildren<{
    gestures: (FlingGesture | PinchGesture)[] | undefined;
}>) {
    return !isWeb && gestures?.length ? (
        <GestureDetector gesture={Gesture.Race(...gestures)}>
            {children}
        </GestureDetector>
    ) : (
        <>{children}</>
    );
}

export default GestureHandlerComponent;
